export default __webpack_public_path__ + "static/banner-four-main-img-bd63e875bcd3c865fc9fbf9db64bca27.png";